import Tooltip from "../../../components/common/tooltip/tooltip"
import { Button, Dropdown, Tag } from "components/common"
import { useLazyGetClientCellsQuery } from "features/shared/api"
import { usePbxCallMutation } from "features/tsr/apis"
import { useMemo } from "react"

const PBXCallButton = props => {
  const { client, size, disabled, leadId, from, ...buttonProps } = props
  const [getClientCellInfo, { data: clientCells }] = useLazyGetClientCellsQuery()
  const [pbxCall, { error, isError }] = usePbxCallMutation()

  const callOnPBX = cellNumber => {
    pbxCall({ number: cellNumber })
  }

  const onClick = e => {
    e.domEvent.stopPropagation()
    callOnPBX(clientCells?.[e.key]?.number)
  }

  const onCopy = e => {
    e.preventDefault()
  }
  const onContextMenu = e => {
    e.preventDefault()
  }

  const items = useMemo(
    () =>
      clientCells?.map((e, index) => {
        return {
          label: (
            <div className="d-flex flexYcenter" style={{ gap: "6px" }}>
              {e.number}
              <Tooltip title={e.lastUsedDateTime}>
                <Tag pill style={{ color: "#0091ba", "--tag-bg": "#E6F5F9" }}>
                  {e.lastUsed}
                </Tag>
              </Tooltip>
            </div>
          ),
          key: index,
        }
      }),
    [clientCells]
  )

  return (
    <Dropdown
      menu={{ items, onClick, onCopy, onContextMenu }}
      dropdownRender={menu => (items?.length ? <div className="dropdown-content">{menu}</div> : <></>)}
      placement="bottomLeft"
      suffixIcon=""
      disabled={disabled}
    >
      <Button
        icon={"FiPhoneCall"}
        onClick={e => {
          e.stopPropagation()
          getClientCellInfo({ clientId: client?.id, actionType: "tooltip&includeLastUsed=true" })
        }}
        content="Pbx"
        color="#FC976E"
        type="light"
        {...buttonProps}
      />
    </Dropdown>
  )
}

export default PBXCallButton
